import UserCombobox from "components/directus/combobox/user";
import { usePermissions } from "contexts/permission";
import Headerportal from "components/portal/header-portal";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";

export default function JobsOverviewFilters({ filters, setFilters }) {
  const handleEmployeeChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      employeeId: value || undefined, // Use undefined instead of null for clearing
    }));
  };
  const { user_config, role } = useSelector(selectUser);

  return (
    <Headerportal>
      <UserCombobox
        value={filters?.employeeId || null}
        onChange={handleEmployeeChange}
        className="w-50"
        searchPlaceholder="Search employee..."
        hideLabel={true}
        clearable={true}
      />
    </Headerportal>
  );
}
